import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard, publicAuthGuard } from './core/auth.guard';
import { LoginComponent } from './login/login.component';
import { ResetPasswordComponent } from './login/reset-password.component';
import { PageNotFoundComponent } from './page-not-found.component';
import { SuperAdminManagementComponent } from './super-admin/super-admin-management.component';
import { SuperAdminSettingsComponent } from './super-admin-settings/super-admin-settings.component';
import { GeneralSignUpComponent } from './sign-up/general-sign-up.component';
import { SuperAdminMemberManagementComponent } from './super-admin-member-management/super-admin-member-management.component';
import { PendingApplicationsComponent } from './pending-applications/pending-applications.component';
import { PendingApplicationDetailsComponent } from './pending-applications/pending-application-details.component';
import { PendingNewsComponent } from './pending-news/pending-news.component';
import { PendingNewsArticleComponent } from './pending-news/pending-news-article.component';
import { PendingLettersComponent } from './pending-letters/pending-letters.component';
import { PendingLetterDetailsComponent } from './pending-letters/pending-letter-details.component';
import { SubmitMemberNewsComponent } from './member-news/submit-member-news.component';
import { MemberUserManagementComponent } from './member-admin/member-user-management/member-user-management.component';
import { MembershipManagementComponent } from './member-admin/membership-management/membership-management.component';
import { AdminPortalBaseComponent } from './admin-portal-base.component';
import { PublicPortalBaseComponent } from './public-portal/public-portal-base.component';
import { MemberDirectoryComponent } from './public-portal/member-information/member-directory/member-directory.component';
import { MemberProfileComponent } from './public-portal/member-information/member-directory/member-profile.component';
import { MemberDiscountsComponent } from './public-portal/member-information/member-discounts/member-discounts.component';
import { MemberNewsFeedComponent } from './public-portal/member-information/member-news/member-news-feed.component';
import { ClaimMemberDiscountComponent } from './public-portal/member-information/member-discounts/claim-member-discount.component';
import { SubmitMemberAdComponent } from './member-ads/submit-member-ad.component';
import { SubmitMemberDiscountComponent } from './member-discount/submit-member-discount.component';
import { PendingDiscountsListComponent } from './member-discount/pending-discounts-list.component';
import { PendingDiscountReviewComponent } from './member-discount/pending-discount-review.component';
import { SuperAdminChamberPerkManagementComponent } from './super-admin-member-management/super-admin-chamber-perk-management.component';
import { SuperAdminChamberPerkDetailsComponent } from './super-admin-member-management/super-admin-chamber-perk-details.component';
import { MemberDashboardComponent } from './member-admin/member-dashboard/member-dashboard.component';
import {PendingAdsListComponent} from "./member-ads/pending-ads-list.component";
import {PendingAdDetailsComponent} from "./member-ads/pending-ad-details.component";
import { AdsComponent } from './member-ads/ads.component';
import { MemberNewsArticleComponent } from './public-portal/member-information/member-news/member-news-article.component';
import { SuperAdminMemberDetailsComponent } from './super-admin-member-management/super-admin-member-details.component';
import { MemberAccountComponent } from './public-portal/member-information/member-account/member-account.component';
import { MemberInvoicesComponent } from './member-admin/member-invoices/member-invoices.component';
import { MemberInvoiceDetailsComponent } from './member-admin/member-invoices/member-invoice-details.component';
import { MemberNonInvoicePaymentDetailsComponent } from './member-admin/member-invoices/member-non-invoice-payment-details.component';
import { PaymentHistoryComponent } from './payment-history/payment-history.component';
import { ResourcesListComponent } from './super-admin-resources/resources-list.component';
import { ResourceDetailsComponent } from './super-admin-resources/resource-details.component';
import { ResourcePageDetailsComponent } from './public-portal/member-information/member-resources/resource-details.component';
import { ResourcesDirectoryListComponent } from './public-portal/member-information/member-resources/resources-list.component';
import { PublicPaymentsComponent } from './public-portal/public-payments/public-payments.component';

const routes: Routes = [
  {
    path: "admin-portal",
    component: AdminPortalBaseComponent,
    children: [
      {
        path: 'login',
        component: LoginComponent
      },
      {
        path: 'reset-password/:token',
        component: ResetPasswordComponent
      },
      {
        path: 'sign-up/general',
        component: GeneralSignUpComponent
      },
      {
        path: 'sign-up/startup',
          component: GeneralSignUpComponent,
          data: {appType: "startup"},
        },
        {
            path: 'sign-up/chambercare',
            component: GeneralSignUpComponent,
            data: { appType: "chambercare" },
        },
      //super admin
      {
        path: 'chamber/super-admin-management',
        component: SuperAdminManagementComponent,
        canActivate: [authGuard]
      },
      {
        path: 'chamber/payment-history',
        component: PaymentHistoryComponent,
        canActivate: [authGuard]
      },
      {
        path: 'chamber/super-admin-member-management',
        component: SuperAdminMemberManagementComponent,
        canActivate: [authGuard]
      },
      {
        path: 'chamber/chamber-perks-management',
        component: SuperAdminChamberPerkManagementComponent,
        canActivate: [authGuard]
      },
      {
        path: 'chamber/chamber-perk-detail/:discountId',
        component: SuperAdminChamberPerkDetailsComponent,
        canActivate: [authGuard]
        },
        {
            path: 'chamber/super-admin-resources',
            component: ResourcesListComponent,
            canActivate: [authGuard]
        },
        {
            path: 'chamber/resource-page/details/:id',
            component: ResourceDetailsComponent,
            canActivate: [authGuard]
        },
      {
        path: 'chamber/super-admin-settings',
        component: SuperAdminSettingsComponent,
        canActivate: [authGuard]
      },
      //member admin
      {
        path: 'member/user-management',
        component: MemberUserManagementComponent,
        canActivate: [authGuard]
      },
      {
        path: 'member/membership-management',
        component: MembershipManagementComponent,
        canActivate: [authGuard]
      },
      {
        path: 'member/invoice-management',
        component: MemberInvoicesComponent,
        canActivate: [authGuard]
      },
      {
        path: 'member/invoice-payment/:invoiceIds',
        component: MemberInvoiceDetailsComponent,
        canActivate: [authGuard]
      },
      {
        path: 'member/non-invoice-payment',
        component: MemberNonInvoicePaymentDetailsComponent,
        canActivate: [authGuard]
      },
      {
        path: 'member/dashboard',
        component: MemberDashboardComponent,
        canActivate: [authGuard]
      },
          // Engagement
      {
        path: 'member/submit-member-news',
        component: SubmitMemberNewsComponent,
        canActivate: [authGuard]
      },
      {
          path: 'member/submit-member-ad/:adtype',
          component: SubmitMemberAdComponent,
          canActivate: [authGuard]
        },
        {
            path: 'member/member-ads',
            component: AdsComponent,
            canActivate: [authGuard]
        },
      {
          path: 'member/submit-member-discount',
          component: SubmitMemberDiscountComponent,
          canActivate: [authGuard]
      },
      // Pending apps
      {
        path: 'chamber/pending-applications',
        component: PendingApplicationsComponent,
        canActivate: [authGuard]
      },
      {
        path: 'chamber/pending-applications/details/:id',
        component: PendingApplicationDetailsComponent,
        canActivate: [authGuard]
      },  
      {
        path: 'chamber/pending-news',
        component: PendingNewsComponent,
        canActivate: [authGuard]
      },
      {
        path: 'chamber/pending-news/details/:id',
        component: PendingNewsArticleComponent,
        canActivate: [authGuard]
      },
      {
        path: 'chamber/pending-ads',
        component: PendingAdsListComponent,
        canActivate: [authGuard]
      },
      {
        path: 'chamber/pending-ads/details/:id',
        component: PendingAdDetailsComponent,
        canActivate: [authGuard]
      },
      {
        path: 'chamber/pending-letters',
        component: PendingLettersComponent,
        canActivate: [authGuard]
      },
      {
        path: 'chamber/pending-letters/details/:id',
        component: PendingLetterDetailsComponent,
        canActivate: [authGuard]
      },
      {
        path: 'chamber/pending-discounts',
        component: PendingDiscountsListComponent,
        canActivate: [authGuard]
      },
      {
        path: 'chamber/pending-discounts/details/:id',
        component: PendingDiscountReviewComponent,
        canActivate: [authGuard]
      },
      {
        path: 'chamber/member-management/:id',
        component: SuperAdminMemberDetailsComponent,
        canActivate: [authGuard]
      },
      {
        path: 'page-not-found',
        component: PageNotFoundComponent,
        canActivate: [authGuard]
      },
    ]
  },
  {
    path: "public",
    component: PublicPortalBaseComponent,
    children: [
      {
        path: 'public-payments',
        component: PublicPaymentsComponent
      },
      {
      path: 'member-directory',
      component: MemberDirectoryComponent
    },
    {
      path: 'member-profile/:memberId',
      component: MemberProfileComponent
    },
    {
      path: 'member-news',
      component: MemberNewsFeedComponent
    },
    {
      path: 'member-news/article/:articleId',
      component: MemberNewsArticleComponent
    },
    {
      path: 'member-discounts',
      component: MemberDiscountsComponent,
      canActivate: [publicAuthGuard]
    },    {
      path: 'claim-member-discount/:discountId',
      component: ClaimMemberDiscountComponent,
      canActivate: [publicAuthGuard]
    },
    {
        path: 'resources',
        component: ResourcesDirectoryListComponent,
        canActivate: [publicAuthGuard]
    },
    {
        path: 'resources/resource-page/:pageId',
        component: ResourcePageDetailsComponent,
        canActivate: [publicAuthGuard]
    },
    {
        path: 'my-account',
        component: MemberAccountComponent,
        canActivate: [publicAuthGuard]
    },
    ]
  },
  //misc
 
  {
    path: 'admin-portal',
    redirectTo: 'admin-portal/login',
    pathMatch: 'prefix'
  },
  {
    path: '',
    redirectTo: 'public/member-directory',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: 'admin-portal/page-not-found'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
